// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__kS+yg","spinner1":"Spinner_spinner1__7MTKB"};